import type {Result, UseCase} from 'framework';
import type {NutritionLabelScanResult} from '../../domain/product';
import type {ProductError} from '../../domain/errors';
import type {ProductRepository} from '../ports/product.repository';

export type ScanNutritionLabelInput = {
  readonly image: File;
};

export class ScanNutritionLabel implements UseCase<
  [ScanNutritionLabelInput],
  NutritionLabelScanResult
> {
  constructor(private readonly repository: ProductRepository) {}

  execute(input: ScanNutritionLabelInput): Promise<Result<NutritionLabelScanResult, ProductError>> {
    return this.repository.scanNutritionLabel(input.image);
  }
}
